import React from 'react';
import styles from './PageContainer.module.css';

// PageContainer — page-level width clamp primitive. Mirrors the iOS
// AdaptiveContentContainer.WidthPolicy enum (see
// Housfully/DesignSystem/Adaptive/AdaptiveContentContainer.swift).
//
// Use this as the page-content wrapper inside the outermost background
// wrapper of a route. The outer wrapper keeps its full-bleed background
// (and any header chrome that should run edge-to-edge); PageContainer
// centers and clamps the inner content so iPad / wide windows don't
// strand single-column content across the whole canvas.

const clsx = (...args) => args.filter(Boolean).join(' ');

const MAX_WIDTHS = ['fluid', 'form', 'readable', 'wide', 'app', 'desktop'];

const PageContainer = React.forwardRef(function PageContainer(
  { children, maxWidth = 'app', as: Tag = 'div', className, ...rest },
  ref
) {
  const policy = MAX_WIDTHS.includes(maxWidth) ? maxWidth : 'app';
  return (
    <Tag
      ref={ref}
      className={clsx(styles.container, styles[policy], className)}
      {...rest}
    >
      {children}
    </Tag>
  );
});

export default PageContainer;
